/**
 * Upload unsigned de imagens no Cloudinary (mesma conta/preset do mobile).
 * O backend só aceita uma URL no campo `photoUrl`, então a foto é enviada
 * diretamente do navegador para o Cloudinary antes do envio da solicitação.
 */

const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || 'dhfg838xl';
const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || 'pesqueira_iluminada';

const FOLDER = 'postes';

export const MAX_PHOTO_SIZE_BYTES = 5 * 1024 * 1024; // 5 MB

export function isImageFile(file: File): boolean {
  return file.type.startsWith('image/');
}

/** Faz upload de um arquivo de imagem e retorna a URL pública segura (HTTPS). */
export async function uploadPhoto(file: File): Promise<string> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', UPLOAD_PRESET);
  formData.append('folder', FOLDER);

  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
    { method: 'POST', body: formData },
  );

  let data: any;
  try {
    data = await res.json();
  } catch {
    throw new Error(`Falha no upload da foto (${res.status}).`);
  }

  if (!res.ok) {
    throw new Error(
      data?.error?.message || `Falha no upload da foto (${res.status}).`,
    );
  }

  const secureUrl = data?.secure_url as string | undefined;
  if (!secureUrl) {
    throw new Error('O servidor de fotos não retornou uma URL válida.');
  }

  return secureUrl;
}
